// eslint-disable-next-line import/no-named-default
import StandardChart, { setStandardChartIns } from './core/StandardChart';
import { debug } from './util/debug';
import { version as VERSION } from '../package.json';

export { getStandardChartInsById } from './core/StandardChart';

let idBase = +new Date() - 0;
const DOM_ATTRIBUTE_KEY = '_sc_instance_';
/**
 * 初始化一个图表组件
 */
export function init(...args: ConstructorParameters<typeof StandardChart>) {
  debug('init: %o', args);
  const isClient = !(args[3] && args[3].ssr);

  if (typeof args[0] === 'string') {
    if ((args[0] as string).startsWith('.') || (args[0] as string).startsWith('#')) {
      args[0] = document.querySelector(args[0]);
    } else {
      args[0] = document.querySelector(`#${args[0]}`);
    }
  }
  if (!args[0]) {
    throw new Error(`"dom" should be an selector or an HTMLElement.`);
  }

  const chart = new StandardChart(...args);
  (chart as unknown as { version: string }).version = VERSION;
  chart.id = `sc_${idBase++}`;
  setStandardChartIns(chart);

  if (isClient) {
    args[0].setAttribute
      ? args[0].setAttribute(DOM_ATTRIBUTE_KEY, chart.id)
      : (args[0][DOM_ATTRIBUTE_KEY] = chart.id);
  }

  return chart;
}
